module.exports = __webpack_public_path__ + "img/background6.c7f283ca.jpg";